import * as React from 'react';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';

// utils regex
import { emailcapsRegEx } from 'src/utils/RegexUtils';

// Style
import '../ProductWarrantyClaimForm.scss';

interface IServiceInfofieldsProps {
  email: string;
  phonenumber: string;
  errorlist: any;
  errorshowmsg: boolean;
  fieldstoshow: any;
  handleEmailChange: (event: any) => void;
  handlePhonenumberChange: (event: any) => void;
}
// interface IServiceInfofieldsState{

// }

class ServiceInfofields extends React.Component<IServiceInfofieldsProps> {
  constructor(props: IServiceInfofieldsProps) {
    super(props);
  }

  public render() {
    return (
      <div>
        {this.props.fieldstoshow &&
          this.props.fieldstoshow['emailServicer'] !== '' &&
          this.props.fieldstoshow['emailServicer'] &&
          this.props.fieldstoshow['emailServicer'][0] === 'true' && (
            <h4>{i18n.t('partClaim.Servicerinfo')}</h4>
          )}
        <div className="form-row row brand-info mb-0">
          {this.props.fieldstoshow &&
            this.props.fieldstoshow['emailServicer'] !== '' &&
            this.props.fieldstoshow['emailServicer'] &&
            this.props.fieldstoshow['emailServicer'][0] === 'true' && (
              <div className="form-group col-sm-12 col-md-3 col-lg-3 mb">
                <label
                  className="form-control-placeholder"
                  htmlFor="consumeremail"
                >
                  {i18n.t('partClaim.servicerEmail')}:
                  {this.props.fieldstoshow &&
                    this.props.fieldstoshow['emailServicer'] &&
                    this.props.fieldstoshow['emailServicer'][1] ===
                      'required' && <span className="required">*</span>}
                </label>
                <input
                  className={`form-control ${
                    this.props.errorlist?.servicerEmailError
                      ? 'is-invalid'
                      : this.props.errorshowmsg &&
                        this.props.email.trim() === '' &&
                        this.props.fieldstoshow['emailServicer'][1] ===
                          'required'
                      ? 'form-control-error-border'
                      : ''
                  }`}
                  name="email"
                  type="text"
                  value={this.props.email}
                  onChange={this.props.handleEmailChange}
                />

                <span className="rp-warranty-input-error-internal">
                  {this.props.errorlist?.servicerEmailError ? (
                    this.props.email === '' ? (
                      `${i18n.t('partClaim.reqfield')}`
                    ) : this.props.email.length > 50 &&
                      !emailcapsRegEx.test(this.props.email) ? (
                      <>
                        <p>{i18n.t('partClaim.emailexceederror')}</p>
                        <p>{i18n.t('partClaim.emailerror')}</p>
                      </>
                    ) : !emailcapsRegEx.test(this.props.email) ? (
                      `${i18n.t('partClaim.emailerror')}`
                    ) : this.props.email.length > 50 ? (
                      <>
                        <p>{i18n.t('partClaim.emailexceederror')}</p>
                      </>
                    ) : (
                      ''
                    )
                  ) : (
                    ''
                  )}
                </span>
              </div>
            )}
          {this.props.fieldstoshow &&
            this.props.fieldstoshow['servicerPhoneNumber'] !== '' &&
            this.props.fieldstoshow['servicerPhoneNumber'] &&
            this.props.fieldstoshow['servicerPhoneNumber'][0] === 'true' && (
              <div className="form-group col-sm-12 col-md-3 col-lg-3 mb">
                <label
                  className="form-control-placeholder"
                  htmlFor="consumeremail"
                >
                  {i18n.t('partClaim.servicerPhone')}:
                  {this.props.fieldstoshow &&
                    this.props.fieldstoshow['servicerPhoneNumber'] &&
                    this.props.fieldstoshow['servicerPhoneNumber'][1] ===
                      'required' && <span className="required">*</span>}
                </label>
                <input
                  className={`form-control ${
                    this.props.errorlist?.servicerphoneError
                      ? 'is-invalid'
                      : this.props.errorshowmsg &&
                        this.props.phonenumber === '' &&
                        this.props.fieldstoshow &&
                        this.props.fieldstoshow['servicerPhoneNumber'] &&
                        this.props.fieldstoshow['servicerPhoneNumber'][1] ===
                          'required'
                      ? 'form-control-error-border'
                      : ''
                  }`}
                  name="customer.servicephone"
                  type="text"
                  placeholder="xxx-xxx-xxxx"
                  value={this.props.phonenumber}
                  onChange={this.props.handlePhonenumberChange}
                />

                <span className="rp-warranty-input-error-internal">
                  {this.props.errorlist?.servicerphoneError
                    ? ` ${i18n.t('partClaim.phonerror')}`
                    : ''}
                </span>
              </div>
            )}
        </div>
      </div>
    );
  }
}
export default ServiceInfofields;
